import Todo from './Todo';
import { CSSTransitionGroup } from "react-transition-group";


function TodoList({ todosArr, component, componentClassName }) {

    let todosHTMLItems = todosArr.map(todoObj => {
        return <Todo key={todoObj.id} todoDetails={todoObj} />;
    });

    return (
        <CSSTransitionGroup
            component={component}
            className={componentClassName}
            transitionName="items-list"
            transitionEnter={true}
            transitionLeave={true}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={600}
            transitionAppear={true}
            transitionAppearTimeout={500}
        >
            {todosHTMLItems}
            {todosHTMLItems.length < 1 && (<h3>...</h3>)}
        </CSSTransitionGroup>
    );

}

export default TodoList;